<template>
    <div class="moment-wrapper">
        <div class="moment-background"></div>
        <div :data-height="size" class="moment">
            <div class="moment-loader" v-if="loading">
                <div class="loader">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div class="moment-header">
                <div class="moment-header-favicon" />
                <div class="moment-header-title">{{ title }}</div>
                <a-icon type="close" class="moment-close" @click="$emit('close')" />
            </div>
            <div data-ios="false" class="moment-frame-wrapper">
                <iframe
                    @load="loading = false"
                    :src="url"
                    id="main-content-iframe"
                    sandbox="allow-forms allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InFrame",
    props: ["url", "size"],
    data() {
        return {
            loading: true,
            title: "",
        };
    },
    mounted() {
        const re = new RegExp("://calendar");
        const containsUrl = re.test(this.url);
        if (containsUrl) this.title = "Supsis Reservation";
    },
    methods: {
        loaded() {
            this.loading = false;
            this.title = document.getElementById("main-content-iframe").contentWindow.document.title;
        },
    },
};
</script>

<style lang="scss" scoped>
.moment-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-end;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 999999999999999999999999;

    .moment-background {
        background: rgba(0, 0, 0, 0.3);
        border-radius: 15px;
        cursor: pointer;
        display: flex;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }

    .moment {
        background: #fff;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: relative;

        &-header {
            align-items: center;
            border-bottom: 1px solid #dbe1e8;
            display: flex;
            height: 40px;
            padding: 0 20px;
            position: relative;

            &-favicon {
                border-radius: 4px;
                height: 25px;
                overflow: hidden;
                width: 25px;
            }

            &-title {
                flex: 1 0;
                font-size: 16px;
                line-height: 20px;
                overflow: hidden !important;
                padding: 0 10px;
                text-align: center;
                text-overflow: ellipsis;
                white-space: nowrap;

                &[text-max-lines="1"] {
                    word-wrap: break-word;
                    line-height: 20px;
                    max-height: 20px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                &[text-max-lines="2"] {
                    word-wrap: break-word;
                    line-height: 20px;
                    max-height: 40px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                &[text-max-lines="3"] {
                    word-wrap: break-word;
                    line-height: 20px;
                    max-height: 60px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                &[text-max-lines="4"] {
                    word-wrap: break-word;
                    line-height: 20px;
                    max-height: 80px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            .moment-close {
                cursor: pointer;
                transition: all 0.3s;

                &:hover {
                    opacity: 0.8 !important;
                }

                &:active {
                    opacity: 0.5 !important;
                }

                &:disabled {
                    opacity: 0.2;
                }
            }
        }

        &-frame-wrapper {
            flex: 1 0;

            iframe {
                border: 0;
                width: 100%;
            }

            &[data-ios="false"] iframe {
                height: 100%;
            }

            &[data-ios="true"] {
                overflow: scroll;

                iframe {
                    min-height: 100%;
                }
            }
        }

        &[data-height="full"] {
            flex: 1 1;
        }

        &[data-height="tall"] {
            flex: 0 1 450px;
        }

        &[data-height="compact"] {
            flex: 0 1 280px;
        }

        &-loader {
            align-items: center;
            background: #fff;
            bottom: 0;
            display: flex;
            justify-content: center;
            left: 0;
            position: absolute;
            right: 0;
            top: 0;

            .loader {
                display: flex;

                & > div {
                    animation: moment-indicator 1.5s ease-in-out infinite both;
                    animation-delay: 0s;
                    border-radius: 100%;
                    height: 15px;
                    margin: 0 4px;
                    width: 15px;

                    &:first-child {
                        animation-delay: -0.1875s;
                    }

                    &:last-child {
                        animation-delay: 0.375s;
                    }
                }
            }
        }

        @keyframes moment-indicator {
            0%,
            to {
                background: #9ba6b3;
                transform: scale(1.3);
            }
            50% {
                background: #516173;
                transform: scale(0.7);
            }
        }
    }
}
</style>
